import script from "./ArrangeDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./ArrangeDisplay.vue?vue&type=script&setup=true&lang=js"

import "./ArrangeDisplay.vue?vue&type=style&index=0&id=ac288884&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac288884"]])

export default __exports__